export default "__VITE_ASSET__DhrZmYP8__"